import {Component, OnInit, OnDestroy, Input, Output, EventEmitter} from '@angular/core';

import {SpinnerService} from '../../services/spinner.service';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit, OnDestroy {
    @Output() showChange = new EventEmitter();

    @Input() name: string;
    @Input() loadingImage: string;

    private isShowing: boolean = false;
    @Input()
    get show(): boolean {
        return this.isShowing;
    }
    set show(val: boolean) {
        this.isShowing = val;
        this.showChange.emit(this.isShowing);
    }

    constructor(private spinnerService: SpinnerService) {
    }

    ngOnInit() {
        if (!this.name) {
            throw new Error('Spinner must have a "name" attribute.');
        }

        this.spinnerService._register(this);
    }

    ngOnDestroy(): void {
        this.spinnerService._unregister(this);
    }

}



// WEBPACK FOOTER //
// ./src/app/core/components/spinner/spinner.component.ts